import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";
import { constructSearchParams } from "utils/constructSearchParams";

const getAllStresses = async () => {
  try {
    const res = await axiosInstance.get(
      `${URLS.externalRequests}/agro/stresses/`
    );
    return res;
  } catch (err) {
    console.error("Error fetching stresses:", err);
    throw err;
  }
};

const getAllStressesOfCrop = async (cropId) => {
  const params = constructSearchParams({ cropId });

  try {
    let res = await axiosInstance.get(
      `${URLS.externalRequests}/agro/stresses/`,
      {
        params,
      }
    );
    if (res.data.length === 0) {
      console.error("CropId:", cropId, "does not have stresses");
      res = await getAllStresses();
    }
    return res;
  } catch (err) {
    console.error("Error fetching stresses for cropId:", cropId, err);
    const res = await getAllStresses();
    return res;
  }
};

const getActiveSubstances = (cropId, options = {}) => {
  const params = constructSearchParams({ cropId });

  const finalOptions = { ...options, params };

  return axiosInstance.get(
    `${URLS.externalRequests}/agro/crop-agrochemicals/`,
    finalOptions
  );
};

const getFertilizers = (params = {}) => {
  const finalParams = constructSearchParams(params);

  return axiosInstance.get(`${URLS.externalRequests}/agro/fertilizers/`, {
    params: finalParams,
  });
};

export const cropsApi = {
  stresses: getAllStressesOfCrop,
  activeSubstances: getActiveSubstances,
  fertilizers: getFertilizers,
};
